import { createSlice, createAsyncThunk , nanoid} from "@reduxjs/toolkit";
import { setMessage } from "./message";


const initialState = { 
  name: "New Image",
  width: 8,
  height: 8,
  defaultDuration: 100,
  frames: [],
  selectedFrame: "",
  selectedColor: "#FFFFFF",
  selectedTool: "brush",
  doneLoading: false,
};

const getFrame = (img,frameIndex, width, height) => {
  //internal helper to get the pixel array from the image string

  let pixels = [];

  let frame = {
    duration: 0,
    pixels: pixels,
  };

  let offset = 0;

  if (frameIndex == 0)
  {
    offset = 12;
  }
  else
  {
    offset = ((((width * height) * 6) + 4) * frameIndex) + 12;
  }

  frame.duration = parseInt(img.substring(offset, offset + 4), 16)
  
  offset = offset + 4;

  let pixelsInString = width * height;

  for (let i = 0; i < pixelsInString; i++) {

    let pixStart = offset + (i*6);

    pixels.push(img.substring(pixStart,pixStart + 6 ))
  }

  frame.pixels = pixels;

  return frame;

}

export const selectImageString = (state) => {
  //return state.items.map(item => item.id)

  let imageString = "";

  let image = state.imageEditor;
  //debugger;

  //add header 
  let columns = image.width.toString(16).padStart(4,"0")
  let rows = image.height.toString(16).padStart(4,"0")
  let frames = image.frames.length.toString(16).padStart(4,"0")
  imageString = imageString + columns + rows + frames;

  //now loop over the frames and add them
  image.frames.map((frame) => {

    let duration = "0000";

    //add the duration
    if (frames > 1)
    {
      duration = frame.duration.toString(16).padStart(4,"0");
    }

    imageString = imageString + duration;

    frame.pixels.map((pixel) => {
      imageString = imageString + pixel;
    })
  })

  return imageString;
}

export const selectPixel = (state, frameId,pixelIndex) => {

  let frame = state.imageEditor.frames.find((frame) => frame.id === frameId);

  if(frame == undefined){
    //debugger;

  }
  return frame?.pixels[pixelIndex];

}





const signImageEditorSlice = createSlice({
  name: "imageEditor",
  initialState,

  reducers:{

    setColor(state, action) {

      state.selectedColor = action.payload;

    },

    setName(state, action) {

      state.name = action.payload;

    },

    setTool(state, action) {

      state.selectedTool = action.payload;

    },


    setupNewImage(state, action) {

      //clear state 
      Object.assign(state,initialState);

      let pixels = [];

      //loop over the rows and then the columns adding blank pixels
      for(let y = 0; y <  action.payload.height;   y ++){
        for(let x = 0; x <  action.payload.width;   x ++){
          pixels.push("000000");
        }
      }

      let frame1 = {
        id: nanoid(),
        duration: state.defaultDuration,
        pixels: pixels,
      };

      state.frames=[];
      state.frames.push(frame1);
      state.width = action.payload.width;
      state.height = action.payload.height;
      state.name = action.payload.name;
      state.selectedFrame = frame1.id;
      state.selectedTool = "brush";
      state.selectedColor = "#ffffff";
      state.doneLoading = true
    },

    setLoading( state, action){
      state.doneLoading = false;
    },

    setupImage(state, action) {

      //debugger;
      
      state.frames = [];

      let image = action.payload.image
      let framesTotal = parseInt(image.substring(8,12), 16);

      for(let i = 0; i < framesTotal; i++){

        let frame = getFrame(image,i,action.payload.width,action.payload.height)

        frame.id = nanoid();

        state.frames.push(frame);

      }

      let frameId = state.frames[0].id;

      state.width = action.payload.width;
      state.height = action.payload.height;
      state.name = action.payload.name;
      state.selectedFrame = frameId;
      state.selectedTool = "brush";
      state.selectedColor = "#ffffff";
      state.doneLoading = true

    },

    selectFrame(state, action){

      state.selectedFrame = action.payload;

    },

    addFrame(state, action) {

      let pixels = [];

      //loop over the rows and then the columns adding blank pixels

      for(let y = 0; y <  state.height;   y ++){

        for(let x = 0; x <  state.width;   x ++){

          pixels.push("000000");

        }

      }

      let newFrame = {
        id: nanoid(),
        duration: state.defaultDuration,
        pixels: pixels,
      }

      state.frames.push(newFrame);
      state.selectedFrame = newFrame.id;

    },
    updateFrame(state, action){

      let target = state.frames.find((frame) => frame.id === action.payload.updatedFrame.id);

      Object.assign(target,action.payload.updatedFrame)

    },

    updatePixel(state, action){

      //debugger;

      let target = state.frames.find((frame) => frame.id === action.payload.update.frame);

      target.pixels[action.payload.update.pixelIndex] = action.payload.update.color.substring(1)


    },

    deleteFrame(state, action) {

      let frameToDelete = action.payload.id;
      
      

      //state.frames = state.frames.splice(state.frames.findIndex((arrow) => arrow.id === frameToDelete), 1);
      state.frames = state.frames.filter((arrow) => arrow .id !== frameToDelete);

      //set the selected frame to the fits in the list for now 
      let firstFrame = state.frames[0];
      state.selectedFrame = firstFrame.id;
    },

    cloneFrame(state, action) {

      let frameToClone = action.payload.id;

      //state.frames = state.frames.splice(state.frames.findIndex((arrow) => arrow.id === frameToDelete), 1);
      let source = state.frames.find((frame) => frame.id === frameToClone);

      let index = state.frames.findIndex((arrow) => arrow.id === frameToClone);

      let newFrame = {};

      Object.assign(newFrame,source)
      newFrame.id = nanoid();

      let newArray = state.frames.slice()
      newArray.splice(index , 0,newFrame);

      state.frames = newArray;

      
    },



  },
  extraReducers: {
  },
});


const { reducer , actions} = signImageEditorSlice;
export const { setupImage, setupNewImage, addFrame, deleteFrame, cloneFrame, updateFrame , setColor, setTool, updatePixel, setLoading, selectFrame,setName} = actions

export default reducer;